(() => {
  if (window.__kneedeeQuizInit) return;
  window.__kneedeeQuizInit = true;

  const root = document.getElementById("KneeDeeQuiz");
  if (!root) return;

  const stage = root.querySelector("[data-quiz-stage]");
  const progressWrap = root.querySelector("[data-quiz-progress]");
  const progressFill = root.querySelector("[data-quiz-progress-fill]");
  const progressLabel = root.querySelector("[data-quiz-progress-label]");
  const privacy = root.dataset.privacy || "/policies/privacy-policy";
  const terms = root.dataset.terms || "/policies/terms-of-service";
  const urls = {
    single: root.dataset.singleUrl || "/products/kneedee-heat-wrap",
    pair: root.dataset.pairUrl || "/products/kneedee-heat-wrap-pair",
    singleImg: root.dataset.singleImg || "",
    pairImg: root.dataset.pairImg || "",
  };

  const answers = {};
  const history = [];
  let index = 0;
  let interstitialTimer = 0;

  const joined = 1840 + Math.floor((Date.now() % 86400000) / 38000);
  const today = new Date();
  const started = `${String(today.getMonth() + 1).padStart(2, "0")}/${String(today.getDate()).padStart(2, "0")}/${today.getFullYear()}`;

  const screens = [
    {
      id: "age",
      type: "question",
      counted: true,
      intro: true,
      prompt: "Select your age",
      options: [
        { value: "20-29", label: "20-29" },
        { value: "30-39", label: "30-39" },
        { value: "40-49", label: "40-49" },
        { value: "50-59", label: "50-59" },
        { value: "60+", label: "60+" },
      ],
    },
    {
      id: "social",
      type: "interstitial",
      html: () => `
        <div class="kdq-card">
          <p class="kdq-kicker">Based on your age</p>
          <h2 class="kdq-title">People ${esc(answers.age || "your age")} already built a nightly knee ritual</h2>
          <p>A short, at-home session — heat, kneading, and infrared comfort — without a clinic wait.</p>
        </div>
      `,
    },
    {
      id: "tried",
      type: "question",
      counted: true,
      prompt: "Have you tried a focused at-home knee comfort routine?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "yes", label: "Yes", emoji: "✅" },
        { value: "no", label: "Not yet", emoji: "❌" },
      ],
    },
    {
      id: "need-ritual",
      type: "interstitial",
      html: () => `
        <div class="kdq-card">
          <h2 class="kdq-title">You need a ritual that fits real life</h2>
          <p>KneeDee Heat Wrap is cordless warmth + kneading for stiff, tired knees — on the couch, at your desk, or after a walk.</p>
        </div>
      `,
    },
    {
      id: "goal",
      type: "question",
      counted: true,
      prompt: "What's your main goal?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "stiffness", label: "Ease stiffness after sitting", emoji: "🪑" },
        { value: "tired", label: "Warm tired knees after a long day", emoji: "🌙" },
        { value: "ritual", label: "A simple nightly unwind", emoji: "🛋️" },
        { value: "active", label: "Stay comfortable while I stay active", emoji: "🚶" },
      ],
    },
    {
      id: "cheer",
      type: "interstitial",
      html: () => `
        <div class="kdq-card">
          <h2 class="kdq-title">You're going to like this</h2>
          <p>No guesswork. A 10–15 minute session you can actually keep — warmth first, then back to your evening.</p>
          <blockquote class="kdq-quote">
            “I do about 10–15 minutes in the evening and my knees feel looser afterward.”
            <strong>James R. · Heat Wrap</strong>
          </blockquote>
        </div>
      `,
    },
    {
      id: "extras",
      type: "multi",
      counted: true,
      prompt: "What else matters most?",
      promptClass: "kdq-q--plain",
      hint: "Choose all that apply",
      options: [
        { value: "heat", label: "Heat that actually stays on", emoji: "🔥" },
        { value: "cordless", label: "Cordless / hands-free", emoji: "🔋" },
        { value: "both", label: "Comfort for both knees", emoji: "🦵" },
        { value: "desk", label: "Something I can use at my desk", emoji: "💻" },
      ],
    },
    {
      id: "feel",
      type: "question",
      counted: true,
      prompt: "How do your knees feel most days?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "light", label: "Light tightness" },
        { value: "moderate", label: "Moderate stiffness" },
        { value: "heavy", label: "Heavy and tired" },
        { value: "varies", label: "It comes and goes" },
      ],
    },
    {
      id: "which",
      type: "question",
      counted: true,
      prompt: "Which knee needs the most comfort?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "left", label: "Left" },
        { value: "right", label: "Right" },
        { value: "both", label: "Both" },
        { value: "switches", label: "It switches" },
      ],
    },
    {
      id: "profile-load",
      type: "processing",
      title: "Creating your comfort profile",
      steps: ["Updating your goals…", "Matching your comfort type…"],
    },
    {
      id: "when",
      type: "question",
      counted: true,
      prompt: "When do you notice it most?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "morning", label: "Mornings", emoji: "🌅" },
        { value: "sitting", label: "After sitting", emoji: "🪑" },
        { value: "standing", label: "After standing / walking", emoji: "👣" },
        { value: "evening", label: "Evening / end of day", emoji: "🌙" },
      ],
    },
    {
      id: "tried-what",
      type: "multi",
      counted: true,
      prompt: "What have you already tried?",
      promptClass: "kdq-q--plain",
      hint: "Choose all that apply",
      options: [
        { value: "pad", label: "Heating pad" },
        { value: "cream", label: "Creams / rubs" },
        { value: "compression", label: "Compression" },
        { value: "nothing", label: "Nothing yet" },
      ],
    },
    {
      id: "dont-worry",
      type: "interstitial",
      html: () => `
        <div class="kdq-card">
          <h2 class="kdq-title">Don't worry if other things didn't stick</h2>
          <p>Pads cool off. Creams fade. KneeDee is a wrap-and-sit ritual — heat, kneading, and infrared comfort in one cordless session.</p>
        </div>
      `,
    },
    {
      id: "day",
      type: "question",
      counted: true,
      prompt: "How would you describe your typical day?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "sitting", label: "Mostly sitting", emoji: "🪑" },
        { value: "standing", label: "Mostly standing", emoji: "🧍" },
        { value: "mixed", label: "Mixed sitting and standing", emoji: "🔄" },
        { value: "feet", label: "On my feet all day", emoji: "💪" },
      ],
    },
    {
      id: "cadence",
      type: "question",
      counted: true,
      prompt: "How often do you want a session?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "few", label: "A few times a week" },
        { value: "evenings", label: "Most evenings" },
        { value: "daily", label: "Daily" },
        { value: "needed", label: "As needed" },
      ],
    },
    {
      id: "confidence",
      type: "question",
      counted: true,
      prompt: "How ready are you to start a simple knee comfort ritual?",
      promptClass: "kdq-q--plain",
      options: [
        { value: "ready", label: "I'm ready", emoji: "🤩" },
        { value: "willing", label: "Willing to try", emoji: "💪" },
        { value: "unsure", label: "Still unsure", emoji: "🤔" },
      ],
    },
    {
      id: "plan-load",
      type: "processing",
      title: "Building your KneeDee ritual",
      steps: ["Analyzing your answers…", "Designing your session…", "Preparing your match…"],
    },
    {
      id: "email",
      type: "email",
    },
    {
      id: "result",
      type: "result",
    },
  ];

  const countedTotal = screens.filter((s) => s.counted).length;

  function esc(value) {
    return String(value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function countedDone() {
    return screens.slice(0, index + 1).filter((s) => s.counted).length;
  }

  function updateProgress() {
    const screen = screens[index];
    const show = Boolean(screen && !screen.intro && screen.type !== "result");
    progressWrap.hidden = !show;
    if (!show) return;
    const done = Math.min(countedDone(), countedTotal);
    const pct = Math.round((done / countedTotal) * 100);
    progressFill.style.width = `${pct}%`;
    progressLabel.textContent = `${done} / ${countedTotal}`;
  }

  function optionButton(opt, selected) {
    return `
      <button class="kdq-opt${selected ? " is-selected" : ""}" type="button" data-value="${esc(opt.value)}">
        <span class="kdq-opt__label">
          ${opt.emoji ? `<span class="kdq-opt__emoji">${opt.emoji}</span>` : ""}
          <span>${esc(opt.label)}</span>
        </span>
        <span class="kdq-opt__radio" aria-hidden="true"></span>
      </button>
    `;
  }

  function backButton() {
    if (index === 0) return "";
    return `<button class="kdq-back" type="button" data-quiz-back>Back</button>`;
  }

  function recommend() {
    const extras = answers.extras || [];
    const bothKnees =
      answers.which === "both" ||
      answers.which === "switches" ||
      extras.includes("both");
    const pair = bothKnees;
    const feelMap = { light: 28, varies: 42, moderate: 58, heavy: 74 };
    const now = feelMap[answers.feel] || 50;
    const types = {
      stiffness: "Desk-day unwind",
      tired: "After-work warmth",
      ritual: "Nightly knee ritual",
      active: "Active-day recovery",
    };
    const whenMap = {
      morning: "10–15 minutes after you wake, before the day stacks up.",
      sitting: "A short session after long sits — heat first, then back to it.",
      standing: "Park it on after being on your feet. Cordless, couch-friendly.",
      evening: "Your evening wind-down: 10–15 minutes, then lights out.",
    };
    return {
      pair,
      url: pair ? urls.pair : urls.single,
      img: pair ? urls.pairImg : urls.singleImg,
      name: pair ? "KneeDee Heat Wrap Pair" : "KneeDee Heat Wrap",
      price: pair ? "$139" : "$79",
      type: types[answers.goal] || "Everyday knee comfort",
      ritual: whenMap[answers.when] || "A 10–15 minute session whenever your knees feel tired.",
      now,
      goal: 18,
      why: pair
        ? "You marked both knees (or switching sides). A pair means you don’t wait your turn."
        : "A single Heat Wrap is the right start — add a second later if the other knee wants a turn.",
    };
  }

  function renderResult() {
    const rec = recommend();
    const age = answers.age || "your";
    return `
      <div class="kdq-result">
        <div class="kdq-result__hero">
          <p class="kdq-kicker">Your plan is ready</p>
          <h2 class="kdq-title">Here's your personalized knee comfort profile</h2>
          <p class="kdq-sub">Built from your answers · Age ${esc(age)}</p>
        </div>
        <div class="kdq-card">
          <div class="kdq-stats">
            <div class="kdq-stat"><span>Comfort type</span><strong>${esc(rec.type)}</strong></div>
            <div class="kdq-stat"><span>Recommended</span><strong>${esc(rec.pair ? "Pair" : "Single wrap")}</strong></div>
            <div class="kdq-stat"><span>Session</span><strong>10–15 min</strong></div>
            <div class="kdq-stat"><span>Fit</span><strong>${esc(answers.which === "both" ? "Both knees" : answers.which || "Your knee")}</strong></div>
          </div>
          <div class="kdq-meter">
            <div class="kdq-meter__labels"><span>Now</span><span>Your goal</span></div>
            <div class="kdq-meter__track">
              <span class="kdq-meter__now" style="left:${rec.now}%"></span>
              <span class="kdq-meter__goal" style="left:${100 - rec.goal}%"></span>
            </div>
          </div>
          <p>${esc(rec.ritual)}</p>
        </div>
        <div class="kdq-card kdq-product">
          ${rec.img ? `<img src="${esc(rec.img)}" alt="${esc(rec.name)}" width="640" height="480">` : ""}
          <div class="kdq-product__body">
            <h3>${esc(rec.name)}</h3>
            <div class="kdq-price"><strong>${esc(rec.price)}</strong></div>
            <p>${esc(rec.why)}</p>
            <ul class="kdq-bullets">
              <li>Cordless heat, kneading & infrared comfort</li>
              <li>Free shipping on orders $79+</li>
              <li>30-day money-back window</li>
            </ul>
            <div class="kdq-actions">
              <a class="kdq-btn kdq-btn--mint" href="${esc(rec.url)}">Get my ${esc(rec.pair ? "pair" : "Heat Wrap")}</a>
              <a class="kdq-btn kdq-btn--ghost" href="${esc(rec.pair ? urls.single : urls.pair)}">
                See the ${esc(rec.pair ? "single wrap" : "pair")} instead
              </a>
            </div>
            <p class="kdq-fine"><a href="/?view=ritual">Do the free 12-minute ritual tonight</a></p>
            <p class="kdq-guarantee">Try it at home · 30-day comfort guarantee</p>
          </div>
        </div>
        <p class="kdq-fine">
          KneeDee Heat Wrap is a wellness comfort device for warmth and everyday stiffness.
          It is not intended to diagnose, treat, cure, or prevent any disease. If you have a medical condition, talk with your clinician.
        </p>
      </div>
    `;
  }

  function renderScreen() {
    window.clearTimeout(interstitialTimer);
    const screen = screens[index];
    if (!screen) return;
    updateProgress();

    if (screen.type === "email") {
      const source = root.querySelector("[data-quiz-email-source]");
      const formHtml = source ? source.innerHTML : "";
      stage.innerHTML = `
        <div class="kdq-card kdq-email">
          <p class="kdq-kicker">Your match is ready</p>
          <h2 class="kdq-title">Where should we send your evening plan?</h2>
          <p>Get the 12-minute ritual plus your wrap recommendation. Skip if you want the match on-screen only.</p>
          ${formHtml}
          <div class="kdq-actions">
            <button class="kdq-btn kdq-btn--ghost" type="button" data-quiz-next>Skip — show my match</button>
          </div>
          <p class="kdq-fine">No spam. Unsubscribe anytime.</p>
        </div>
        ${backButton()}
      `;
      const cloned = stage.querySelector("#QuizLeadEmail");
      if (cloned) cloned.id = "QuizLeadEmailLive";
      const liveLabel = stage.querySelector("label[for='QuizLeadEmail']");
      if (liveLabel) liveLabel.setAttribute("for", "QuizLeadEmailLive");
      return;
    }

    if (screen.type === "result") {
      stage.innerHTML = renderResult();
      return;
    }

    if (screen.type === "interstitial") {
      stage.innerHTML = `${screen.html()}<div class="kdq-actions"><button class="kdq-btn" type="button" data-quiz-next>Continue</button></div>${backButton()}`;
      interstitialTimer = window.setTimeout(() => go(1), 3200);
      return;
    }

    if (screen.type === "processing") {
      stage.innerHTML = `
        <h2 class="kdq-title">${esc(screen.title)}</h2>
        <div class="kdq-loaders">
          ${screen.steps
            .map(
              (step, i) => `
            <div class="kdq-loader" data-loader="${i}">
              <h3>${esc(step)}</h3>
              <div class="kdq-loader-track"><div class="kdq-loader-fill"></div></div>
              <div class="kdq-loader-pct">0%</div>
            </div>
          `
            )
            .join("")}
        </div>
      `;
      runLoaders().then(() => go(1));
      return;
    }

    const promptClass = screen.promptClass ? `kdq-q ${screen.promptClass}` : "kdq-q";
    const selected = screen.type === "multi" ? answers[screen.id] || [] : answers[screen.id];
    const intro = screen.intro
      ? `
        <div class="kdq-proof">
          <span>📌 Starting date: ${esc(started)}</span>
          <span>🔥 People joined: ${joined}</span>
        </div>
        <p class="kdq-kicker">1 minute personalized quiz</p>
        <h1 class="kdq-title">Get knee comfort for <em>YOUR</em> type</h1>
        <p class="kdq-sub">Heat, kneading, and a ritual that fits your day — not a clinic appointment.</p>
      `
      : "";
    const legal = screen.intro
      ? `<p class="kdq-legal">By selecting your age and continuing you agree to our <a href="${esc(terms)}">Terms of Service</a> | <a href="${esc(privacy)}">Privacy Policy</a><br>Please review before continuing</p>`
      : "";
    const continueBtn =
      screen.type === "multi"
        ? `<div class="kdq-actions"><button class="kdq-btn" type="button" data-quiz-next ${
            Array.isArray(selected) && selected.length ? "" : "disabled"
          }>Continue</button></div>`
        : "";

    stage.innerHTML = `
      ${intro}
      <h2 class="${promptClass}">${esc(screen.prompt)}</h2>
      ${screen.hint ? `<p class="kdq-hint">${esc(screen.hint)}</p>` : ""}
      <div class="kdq-options" data-quiz-options data-mode="${screen.type}">
        ${screen.options.map((opt) => optionButton(opt, screen.type === "multi" ? selected.includes(opt.value) : selected === opt.value)).join("")}
      </div>
      ${continueBtn}
      ${legal}
      ${screen.intro ? "" : backButton()}
    `;
  }

  function runLoaders() {
    const nodes = [...stage.querySelectorAll("[data-loader]")];
    const animate = (el, duration) =>
      new Promise((resolve) => {
        const fill = el.querySelector(".kdq-loader-fill");
        const pct = el.querySelector(".kdq-loader-pct");
        const start = performance.now();
        const tick = (now) => {
          const p = Math.min(1, (now - start) / duration);
          const value = Math.round(p * 100);
          fill.style.width = `${value}%`;
          pct.textContent = `${value}%`;
          if (p < 1) requestAnimationFrame(tick);
          else resolve();
        };
        requestAnimationFrame(tick);
      });

    return nodes.reduce(
      (chain, el, i) => chain.then(() => animate(el, 900 + i * 180)),
      Promise.resolve()
    );
  }

  function go(delta) {
    const next = index + delta;
    if (next < 0 || next >= screens.length) return;
    if (delta > 0) history.push(index);
    index = next;
    renderScreen();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  stage.addEventListener("click", (event) => {
    const back = event.target.closest("[data-quiz-back]");
    if (back) {
      window.clearTimeout(interstitialTimer);
      const prev = history.pop();
      if (typeof prev === "number") {
        index = prev;
        renderScreen();
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
      return;
    }

    const next = event.target.closest("[data-quiz-next]");
    if (next) {
      const screen = screens[index];
      if (screen.type === "multi") {
        const picked = answers[screen.id] || [];
        if (!picked.length) return;
      }
      go(1);
      return;
    }

    const emailForm = event.target.closest(".kdq-email-form");
    if (emailForm && event.type === "click" && event.target.closest("button[type='submit']")) {
      return;
    }

    const opt = event.target.closest(".kdq-opt");
    if (!opt) return;
    const screen = screens[index];
    const value = opt.dataset.value;
    if (screen.type === "multi") {
      const current = new Set(answers[screen.id] || []);
      if (value === "nothing") {
        current.clear();
        current.add("nothing");
      } else {
        current.delete("nothing");
        if (current.has(value)) current.delete(value);
        else current.add(value);
      }
      answers[screen.id] = [...current];
      renderScreen();
      return;
    }

    answers[screen.id] = value;
    go(1);
  });

  stage.addEventListener("submit", async (event) => {
    const form = event.target.closest(".kdq-email-form");
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector("button[type='submit']");
    if (button) {
      button.disabled = true;
      button.textContent = "Saving…";
    }
    try {
      await fetch(form.action || window.location.pathname, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
    } catch (error) {
      /* Continue to the match even if the list signup fails. */
    }
    go(1);
  });

  renderScreen();
})();
